import { render, staticRenderFns } from "./informative.vue?vue&type=template&id=2fa242e6&scoped=true&"
import script from "./informative.vue?vue&type=script&lang=js&"
export * from "./informative.vue?vue&type=script&lang=js&"
import style0 from "./informative.vue?vue&type=style&index=0&id=2fa242e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa242e6",
  null
  
)

export default component.exports